// Accounting Account Receivable Vuex

import state from './receivableStates.js'
import * as getters from './receivableGetters.js'
import * as mutations from './receivableMutations.js'
import * as actions from './receivableActions.js'

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
